import { isValidEmail } from '@/utils/lodash/string'

export function parseEmails(value) {
  return String(value || '')
    .split(/[,\s]+/)
    .map((item) => item.trim())
    .filter((item) => item && isValidEmail(item.toLowerCase()))
}

export function uniqueEmails(list) {
  const seen = new Set()
  return (list || []).filter((email) => {
    const key = String(email).toLowerCase()
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
}

export function collectEmails(emails, inputValue) {
  return uniqueEmails([...(emails || []), ...parseEmails(inputValue)])
}
